import React from 'react';
import {
    Box,
    Typography,
    IconButton,
    ToggleButton,
    ToggleButtonGroup,
    Tooltip,
    TextField,
    MenuItem
} from '@mui/material';
import {
    ChevronLeft,
    ChevronRight,
    Today,
    ViewModule,
    ViewWeek,
    ViewDay
} from '@mui/icons-material';
import { format } from 'date-fns';
import { ar } from 'date-fns/locale';

const CalendarToolbar = ({
    date,
    view,
    onNavigate,
    onView,
    filterPlatform,
    onFilterChange,
    onAddClick,
    label // Rendered by react-big-calendar, usually "Month Year"
}) => {

    const handleNavigate = (action) => {
        onNavigate(action);
    };

    const handleViewChange = (event, newView) => {
        if (newView) {
            onView(newView);
        }
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                alignItems: 'center',
                justifyContent: 'space-between',
                p: 2,
                gap: 2,
                borderBottom: '1px solid',
                borderColor: 'divider',
                bgcolor: 'background.paper',
                borderRadius: '8px 8px 0 0'
            }}
        >
            {/* Left: Navigation and Date Label */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <IconButton onClick={() => handleNavigate('NEXT')} size="small">
                    <ChevronRight />
                </IconButton>
                <IconButton onClick={() => handleNavigate('PREV')} size="small">
                    <ChevronLeft />
                </IconButton>
                <IconButton onClick={() => handleNavigate('TODAY')} size="small">
                    <Today fontSize="small" />
                </IconButton>

                <Typography variant="h6" fontWeight="bold" sx={{ mx: 2, minWidth: 150, textAlign: 'center' }}>
                    {label}
                </Typography>
            </Box>

            {/* Middle: Filters */}
            <Box sx={{ display: 'flex', gap: 2, width: { xs: '100%', md: 'auto' } }}>
                <TextField
                    select
                    size="small"
                    value={filterPlatform}
                    onChange={(e) => onFilterChange(e.target.value)}
                    label="المنصة"
                    sx={{ minWidth: 120 }}
                >
                    <MenuItem value="all">الكل</MenuItem>
                    <MenuItem value="whatsapp">WhatsApp</MenuItem>
                    <MenuItem value="telegram">Telegram</MenuItem>
                    <MenuItem value="facebook">Facebook</MenuItem>
                    <MenuItem value="instagram">Instagram</MenuItem>
                </TextField>
            </Box>

            {/* Right: View Switcher */}
            <ToggleButtonGroup
                value={view}
                exclusive
                onChange={handleViewChange}
                size="small"
                aria-label="calendar view"
            >
                <ToggleButton value="month" aria-label="month view">
                    <Tooltip title="شهر"><ViewModule /></Tooltip>
                </ToggleButton>
                <ToggleButton value="week" aria-label="week view">
                    <Tooltip title="أسبوع"><ViewWeek /></Tooltip>
                </ToggleButton>
                <ToggleButton value="day" aria-label="day view">
                    <Tooltip title="يوم"><ViewDay /></Tooltip>
                </ToggleButton>
            </ToggleButtonGroup>
        </Box>
    );
};

export default CalendarToolbar;
